import React from "react";
import { SvgIcon } from "@progress/kendo-react-common";
import * as svgIcons from "@progress/kendo-svg-icons";
import FastaSelectionForm from "@presentation/components/fasta/FastaSelectionForm";

// Here we just import the FastaSelectionForm component and render it in the FastaFileFormBlock component
// Only thing we do here is some UI formatting
export const FastaFileFormBlock: React.FC = () => {
  return (
    <fieldset className={"k-form-fieldset"}>
      <legend className={"k-form-legend"}>
        <strong>Fasta</strong> <SvgIcon style={{ paddingBottom: "5px" }} icon={svgIcons.fileDataIcon} />
      </legend>
      <FastaSelectionForm />
    </fieldset>
  );
};
